import Const from 'constants';
import {BaseAction} from 'actions';

let KeyPlayerCombinations = {
    setExposureMaxForCombo(params) {
        return {
            type: Const.KEY_PLAYER_STACKING_COMBO_SET_EXPOSURE_MAX,
            params,
        };
    },
};

export default {...BaseAction, ...KeyPlayerCombinations};
